export default __webpack_public_path__ + "static/media/hero-screenshot-2.241aac1f.png";